import { Typography } from "components/parts/Typography/Typography";
import {
  StyledTableCell,
  StyledTable,
  StyledTbody,
  StyledTbodyTd,
  StyledTbodyTr,
  StyledThead,
  StyledTheadTh,
  StyledTheadTr,
} from "components/templates/Table/styled";
import { useConsoleState } from "providers/ConsoleStateProvider";
import React from "react";
import { User } from "types/graphqlapi";
import { UserWithGroup } from "utils/apis/user";
import { getRoleName } from "utils/common";

export const USER_TABLE_HEADER_COLUMN_LIST = [
  {
    columnId: "email",
    columnType: "typography",
    text: "メールアドレス",
    minWidth: "18em",
    width: "1000px",
  },
  {
    columnId: "Group",
    columnType: "typography",
    text: "グループ名",
    minWidth: "15em",
    width: "1000px",
  },
  {
    columnId: "name",
    columnType: "typography",
    text: "ユーザー名",
    minWidth: "15em",
    width: "1000px",
  },
  {
    columnId: "role",
    columnType: "typography",
    text: "権限",
    minWidth: "15em",
    width: "1000px",
  },
] as const;

type UserListProps = {
  userList: UserWithGroup[];
  selectUser: (user: User) => void;
};

export const UserList: React.FC<UserListProps> = ({ userList, selectUser }) => {
  const { selectedGroupId } = useConsoleState();

  return (
    <>
      <StyledTable>
        {selectedGroupId == "" || selectedGroupId == undefined ? (
          <StyledThead>
            <StyledTheadTr>
              {USER_TABLE_HEADER_COLUMN_LIST.map((column) => (
                <StyledTheadTh
                  key={`tableHeaderColumn${column.columnId}`}
                  minWidth={column.minWidth}
                  width={column.width}
                >
                  <StyledTableCell>
                    <Typography text={column.text} />
                  </StyledTableCell>
                </StyledTheadTh>
              ))}
            </StyledTheadTr>
          </StyledThead>
        ) : (
          <StyledThead>
            <StyledTheadTr>
              {USER_TABLE_HEADER_COLUMN_LIST.map((column) => (
                <StyledTheadTh
                  key={`tableHeaderColumn${column.columnId}`}
                  minWidth={column.minWidth}
                  width={column.width}
                >
                  <StyledTableCell>
                    {column.columnId === "Group" ? (
                      ""
                    ) : (
                      <Typography text={column.text} />
                    )}
                  </StyledTableCell>
                </StyledTheadTh>
              ))}
            </StyledTheadTr>
          </StyledThead>
        )}
        {selectedGroupId == "" || selectedGroupId == undefined ? (
          <StyledTbody>
            {userList.map((user) => (
              <StyledTbodyTr
                key={user.id}
                onClick={(e) => {
                  e.stopPropagation();
                  selectUser(user);
                }}
              >
                {USER_TABLE_HEADER_COLUMN_LIST.map((column) => (
                  <StyledTbodyTd
                    key={`${column.columnId}Of${user.id}`}
                    minWidth={column.minWidth}
                    width={column.width}
                  >
                    <StyledTableCell>
                      {column.columnType === "typography" ? (
                        column.columnId === "Group" ? (
                          <Typography text={user.Group.name} />
                        ) : column.columnId === "role" ? (
                          <Typography text={getRoleName(user.role)} />
                        ) : (
                          (() => {
                            const key = column.columnId as keyof typeof user;
                            const userContent = user[key]?.toString();
                            if (typeof userContent === "string")
                              return <Typography text={userContent} />;
                          })()
                        )
                      ) : (
                        ""
                      )}
                    </StyledTableCell>
                  </StyledTbodyTd>
                ))}
              </StyledTbodyTr>
            ))}
          </StyledTbody>
        ) : (
          <StyledTbody>
            {userList.map((user) => (
              <StyledTbodyTr
                key={user.id}
                onClick={(e) => {
                  e.stopPropagation();
                  selectUser(user);
                }}
              >
                {USER_TABLE_HEADER_COLUMN_LIST.map((column) => (
                  <StyledTbodyTd
                    key={`${column.columnId}Of${user.id}`}
                    minWidth={column.minWidth}
                    width={column.width}
                  >
                    <StyledTableCell>
                      {column.columnType === "typography" ? (
                        column.columnId === "Group" ? (
                          ""
                        ) : column.columnId === "role" ? (
                          <Typography text={getRoleName(user.role)} />
                        ) : (
                          (() => {
                            const key = column.columnId as keyof typeof user;
                            const userContent = user[key]?.toString();
                            if (typeof userContent === "string")
                              return <Typography text={userContent} />;
                          })()
                        )
                      ) : (
                        ""
                      )}
                    </StyledTableCell>
                  </StyledTbodyTd>
                ))}
              </StyledTbodyTr>
            ))}
          </StyledTbody>
        )}
      </StyledTable>
    </>
  );
};
